import { Button } from "@blueprintjs/core";
import {
  Cell,
  Column,
  IColumnProps,
  IRegion,
  RenderMode,
  SelectionModes,
  Table as TableBase,
  TableLoadingOption,
  Utils,
} from "@blueprintjs/table";
import { Timestamp } from "@firebase/firestore-types";
import { Users } from "@just-in-types";
import * as format from "date-fns/format";
import { range } from "lodash";
// import { number } from "prop-types";
import * as React from "react";
import { CheckIns } from ".";
import firebase from "../../firebase";
import { firestore } from "../../firebase";
import { assignNiceName, isTimestamp, prettyMobile } from "./helpers";
// import { assignNiceName, isTimestamp, prettyMobile } from "./helpers";

interface Props {
  businessId: string;
  siteId: string;
  checkIns: Users.CheckIn[];
  currentUser?: null | Users.User;
  currentUserEmail: string;
  fontSize: number;
  loading: boolean;
  numRows: number;
  onSetActiveCheckIn: CheckIns["setActiveCheckIn"];
  tableOptions: Users.ColumnOptions[];
  userNotes: any[];
  vehicleState:{};
}

interface VehiclePick {
  docId: string;
  businessId: string;
  combined: string;
  firstName: string;
  make: string;
  mobile: string;
  model: string;
  remainDays?: number;
  siteId: string;
  textSent: boolean;
  timestamp?: null | Timestamp;
  userId: string;
  yearMax: number;
  yearMin: number;
  matches?: any;
}


interface State {
  columns: Array<React.ReactElement<IColumnProps>>;
  coupons: [];
  // iconArr: any;
  numColumns: null | number;
  picks:VehiclePick[][];
  tableBackgroundColor: string;
  tableBorderColor: string;
  tableColumnsCount: number;
  tableColumnsWidth: number[];
  tableFontColor: string;
  tableWidth: number;
  vehiclePickBlock: boolean;
  vehiclePickStatus: {};
  vehiclePickVal: any;
  // userNotes: any[];
}

const getMatchesForVehicle = firebase.functions().httpsCallable("getMatchesForVehicle");

class Table extends React.PureComponent<Props, State> {
  public state: State = {
    columns: [],
    coupons: [],
    numColumns: null,
    picks:[],
    tableBackgroundColor: "",
    tableBorderColor: "",
    tableColumnsCount: 0,
    tableColumnsWidth: [],
    tableFontColor: "",
    tableWidth: 0,
    vehiclePickBlock:false,
    vehiclePickStatus:{},
    vehiclePickVal:[],
    // userNotes: [],
  };

  public async componentWillReceiveProps(newProps, { checkIns: prevCheckIns }: Props) {
    // this.setState({ userNotes: nextProps.userNotes });
    this.colWidth();
    this.getBussData(newProps.businessId);
    const scrollbox = document.querySelector("#chkinwrap_main_block .bp3-table-quadrant-scroll-container");
    if (
      scrollbox &&
      scrollbox.scrollTop &&
      this.props.numRows !== newProps.numRows &&
      this.props.checkIns === newProps.checkIns
    ) {
      scrollbox.scrollTop = 0;
    }
    if (scrollbox && scrollbox.scrollTop && this.props.checkIns !== newProps.checkIns) {
      scrollbox.scrollTop = scrollbox.scrollTop;
    }

    this.subscribeToCoupons(newProps.checkIns, 1);

    // vehicle pick
    if(this.props.checkIns !== newProps.checkIns && newProps.checkIns.length){
      this.getVehicleData(newProps.checkIns);
    }

    if( this.props.vehicleState !== newProps.vehicleState ){

      const { vehiclePickVal } = this.state;

      vehiclePickVal[newProps.vehicleState.curMobile] = newProps.vehicleState;

      this.setState({ vehiclePickVal });

    }

  }  


  public colWidth = () => {
    const tabOption = [...this.props.tableOptions];
    const tableColumnsWidth: number[] = [];

    const colLng = 162;

    tabOption.forEach((ele) => {
      if (ele.enabled) {
        tableColumnsWidth.push(colLng);
      }
    });
    // this.setState({  tableColumnsWidth });
    return tableColumnsWidth;
  };

  // public colWidth = () => {
  //   const tableWidthBlock = document.querySelector<HTMLElement>(
  //     "#chkinwrap_main_block .bp3-table-quadrant-scroll-container"
  //   )!;
  //   const tabOption = [...this.props.tableOptions];
  //   const tableColumnsWidth: number[] = [];

  //   let colLng = 162;
  //   let tabOptionlength = 0;
  //   let colNumber = 0;
  //   const tableWidth = tableWidthBlock ? tableWidthBlock.offsetWidth : 0;
  //   tabOption.forEach((ele) => {
  //     if (ele.enabled) {
  //       tabOptionlength++;
  //     }
  //   });
  //   if (tabOptionlength && tableWidth) {
  //     colLng = tableWidth / tabOptionlength;
  //     colNumber = tabOptionlength - 1;
  //   }
  //   tabOption.forEach((ele) => {
  //     if (ele.enabled) {
  //       tableColumnsWidth.push(Math.round(colLng) - colNumber);
  //     }
  //   });
  //   this.setState({ tableColumnsCount: tabOptionlength, tableColumnsWidth, tableWidth });
  //   return tableColumnsWidth;
  // };

  // public colWidthChange = (index, size) => {
  //   // const tableWidth = this.state.tableWidth;
  //   const numOfCol = this.state.tableColumnsCount;
  //   const tableColumns = [...this.state.tableColumnsWidth];

  //   if (index === numOfCol - 1) {
  //     // if(size >= 2*(defaultColWidth)){
  //     //   tableColumns[index] = (2*(defaultColWidth))-30;
  //     //   tableColumns[index-1] = 30;
  //     // }else{
  //     if (size <= tableColumns[index]) {
  //       tableColumns[index - 1] = tableColumns[index - 1] + (tableColumns[index] - size);
  //     } else {
  //       tableColumns[index - 1] = tableColumns[index - 1] - (size - tableColumns[index]);
  //     }
  //     tableColumns[index] = size;
  //     // }
  //   } else {
  //     // if(size >= 2*(defaultColWidth)){
  //     //   tableColumns[index] = (2*(defaultColWidth))-30;
  //     //   tableColumns[index+1] = 30;
  //     // }else{
  //     if (size <= tableColumns[index]) {
  //       tableColumns[index + 1] = tableColumns[index + 1] + (tableColumns[index] - size);
  //     } else {
  //       tableColumns[index + 1] = tableColumns[index + 1] - (size - tableColumns[index]);
  //     }
  //     tableColumns[index] = size;
  //     // }
  //   }

  //   this.setState({ tableColumnsWidth: tableColumns });
  // };

  public render() {
    const { fontSize, numRows, onSetActiveCheckIn } = this.props;
    const rowHeights = () => range(0, numRows).map(() => fontSize * 7.5);
    // const { tableColumnsWidth } = this.state;

    return (
      <TableBase
        columnWidths={this.colWidth()}
        enableColumnResizing={false}
        enableFocusedCell={true}
        enableRowHeader={false}
        loadingOptions={this.getLoadingOptions()}
        // numRows={numRows}
        numRows={numRows}
        // onColumnWidthChanged={(index, size) => this.colWidthChange(index, size)}
        onColumnsReordered={this.handleColumnsReordered}
        onSelection={onSetActiveCheckIn}
        renderMode={RenderMode.NONE}
        rowHeights={rowHeights()}
        selectedRegionTransform={this.transformSelection}
        selectionModes={SelectionModes.ROWS_AND_CELLS}
      >
        {this.generateColumns()}
      </TableBase>
    );
  }

  private getBussData = async (businessId) => {
    if (businessId !== "") {
      const doc = await firestore
        .collection(`businesses`)
        .doc(businessId)
        .get();
      // console.log(doc);
      const businessData: any = doc.data();
      // console.log(businessData);

      // vehiclePickBlock
      let vehiclePickBlock = false;
      if(businessData.addaNewPickSwitch !== undefined && businessData.addaNewPickSwitch){
        vehiclePickBlock = businessData.addaNewPickSwitch;
      }

      this.setState({ vehiclePickBlock });
  

      if (businessData.colormode !== undefined && businessData.colormode) {
        let tableCellBackground = "#fff";
        if (businessData.checkInsOptions.tableBackgroundColor !== undefined) {
          tableCellBackground = businessData.checkInsOptions.tableBackgroundColor;
        }
        let tableCellBorder = "#d2d6d9";
        if (businessData.checkInsOptions.tableBorderColor !== undefined) {
          tableCellBorder = businessData.checkInsOptions.tableBorderColor;
        }
        let tableCellFontColor = "#fff";
        if (businessData.checkInsOptions.tableFontColor !== undefined) {
          tableCellFontColor = businessData.checkInsOptions.tableFontColor;
        }

        this.setState({
          tableBackgroundColor: tableCellBackground,
          tableBorderColor: tableCellBorder,
          tableFontColor: tableCellFontColor,
        });
      } else {
        if (businessData.darkmode) {
          this.setState({
            tableBackgroundColor: "black",
            tableBorderColor: "#3f3737",
            tableFontColor: "#fff",
          });
        } else {
          this.setState({
            tableBackgroundColor: "#fff",
            tableBorderColor: "#d2d6d9",
            tableFontColor: "#182026",
          });
        }
      }
    }
  };

  private isMembershipExpired = (membership: any): boolean => {
    const expiry = new Date(membership.end_date);
    const today = new Date();
    if (new Date(expiry.toDateString()) < new Date(today.toDateString())) {
      return true;
    }
    return false;
  };

  private generateCellStyles = (membership?: any, covidquestions?: boolean) => {
    if (covidquestions) {
      return {
        alignItems: "center",
        background: "rgba(255, 2, 2, 0.1)",
        // borderBottom: "1px solid red",
        // borderTop: "1px solid red",
        color: "#ff0000",
        display: "flex",
        fontSize: this.props.fontSize,
        fontWeight: 900,
      };
    }
    return {
      alignItems: "center",
      background:
        membership &&
        membership.businessId != null &&
        this.props.businessId === membership.businessId &&
        this.props.businessId === "NGmCd9CIZx2C5GVDvrQH" &&
        !this.isMembershipExpired(membership)
          ? "rgba(15,153,96,.1)"
          : "",
      // borderBottom: membership ? "1px solid green" : "",
      // borderTop: membership ? "1px solid green" : "",
      color:
        membership &&
        membership.businessId != null &&
        this.props.businessId === membership.businessId &&
        !this.isMembershipExpired(membership)
          ? this.props.businessId === "NGmCd9CIZx2C5GVDvrQH"
            ? "#0f9960"
            : "#000"
          : "",
      display: "flex",
      fontSize: this.props.fontSize,
      fontWeight:
        membership &&
        membership.businessId != null &&
        this.props.businessId === membership.businessId &&
        !this.isMembershipExpired(membership)
          ? 900
          : 400,
    };
  };

  private generateColumns = () =>
    this.props.tableOptions
      .filter(({ enabled }) => enabled)
      .map(({ name }, index) => (
        <Column
          cellRenderer={ (rowIndex) => this.assignRenderer(this.props.checkIns, name, rowIndex)}
          key={index}
          name={assignNiceName(name)}
          className={"table_base"}
        />
      ));

  private getCellData<T extends keyof Users.CheckIn>(checkIns: Users.CheckIn[], rowIndex: number, type: T) {
    if (checkIns[rowIndex] && checkIns[rowIndex][type]) {
      return checkIns[rowIndex][type];
    }
    return null;
  }

  private dateofbirthRenderer = (checkIns: Users.CheckIn[], rowIndex: number) => {
    const dateofbirth = this.getCellData(checkIns, rowIndex, "dateofbirth");
    const membership = this.getCellData(checkIns, rowIndex, "membership");
    const covidquestions = this.getCellData(checkIns, rowIndex, "covidquestions") === "yes" ? true : false;

    if (dateofbirth) {
      const prettyDoB = format(isTimestamp(dateofbirth) ? dateofbirth.toDate() : dateofbirth, "M/D/YY");

      return (
        <Cell
          style={{
            ...this.generateCellStyles(membership, covidquestions),
            background: this.state.tableBackgroundColor,
            border: "0.1px solid " + this.state.tableBorderColor,
            color: this.state.tableFontColor,
          }}
        >
          {prettyDoB}
        </Cell>
      );
    }
    return (
      <Cell
        style={{
          ...this.generateCellStyles(membership, covidquestions),
          background: this.state.tableBackgroundColor,
          border: "0.1px solid " + this.state.tableBorderColor,
          color: this.state.tableFontColor,
        }}
      />
    );
  };

  // vehicle Picks start

  private getVehicleData = (checkIns: Users.CheckIn[]) => {

    const { picks } = this.state;

    if(checkIns){
      checkIns.forEach(async (element, index) =>  {
        let query;
        const mobile = element?element.mobile?element.mobile:'':'';
        const business = element?element.businessPath?element.businessPath:'':'';
        const site = element?element.sitePath?element.sitePath:'':'';
        if (business) {
          const businessQuery = await firestore
            .collection("businesses")
            .where("path", "==", business)
            .get();
          let businessDoc;
          if (!businessQuery.empty) {
            businessDoc = businessQuery.docs[0].data();
            // console.log(businessDoc);
            // if (businessDoc.theme && businessDoc.theme.logo) {
            //   this.setState({ logo: businessDoc.theme.logo });
            // }
            if (businessDoc.s3Id || businessDoc.urgId || !site || site === "-") {
              query = await firestore
                .collection("vehiclePicks")
                .where("mobile", "==", mobile)
                .where("businessId", "==", businessDoc.businessId)
                .get();
            } else if (site && site !== "-") {
              const siteQuery = await businessQuery.docs[0].ref
                .collection("sites")
                .where("path", "==", site)
                .get();
              const siteDoc = await siteQuery.docs[0].data();
              const siteId = siteQuery.docs[0].id;
              // if (siteDoc.theme && siteDoc.theme.logo) {
              //   this.setState({ logo: siteDoc.theme.logo });
              // }
              if (siteDoc.s3Id || siteDoc.urgId) {
                query = await firestore
                  .collection("vehiclePicks")
                  .where("mobile", "==", mobile)
                  .where("siteId", "==", siteId)
                  .get();
              } else {
                query = await firestore
                  .collection("vehiclePicks")
                  .where("mobile", "==", mobile)
                  .get();
              }
            } else {
              query = await firestore
                .collection("vehiclePicks")
                .where("mobile", "==", mobile)
                .get();
            }
          }
        } else {
          query = await firestore
            .collection("vehiclePicks")
            .where("mobile", "==", mobile)
            .get();
        }
    
        const picInBlock : any[] = [];
        await query.forEach(async (doc) => {
          const pick = doc.data();
          pick.docId = doc.ref.id;
          
          const result = await getMatchesForVehicle(pick);
          let matches = result.data;
          if (matches === null) {
            matches = [];
          }
          pick.matches = matches;

          if (pick.timestamp) {
            const timestampToDate = pick.timestamp.toDate();
            const diff = new Date().getTime() - new Date(timestampToDate).getTime();
            const delta = diff / 1000;
            const days = Math.floor(delta / 86400);
    

            const remainDays = 90 - (days > 90 ? 90 : days);
            // const remainDays = 90;
            pick.remainDays = remainDays;
            
          }

          picInBlock.push(pick);
        });

        picks[index] = picInBlock;
      });
  
      this.setState({ picks });
    }
  }

  private getVehiclePics = (rowIndex) => {
    const { picks } = this.state;

    let count = 0;
    const res = {pickLength:0, newInventory:0};
    let oldCount = 0;
    const pickLength = picks[rowIndex]?picks[rowIndex].length:0;
    let newInventory = 0;
    if(picks[rowIndex]){
      picks[rowIndex].forEach((pick) => {

        if( pick.matches !== null && pick.matches.length !== 0){
          count++;
        }
        if( pick.matches !== null && pick.matches.length === 0){
          oldCount++;
        }
      });  
    }

    if(count){
      newInventory = 1;
    }

    if(count === 0 && oldCount > 0){
      newInventory = 2;
    }

    res.pickLength = pickLength;
    res.newInventory = newInventory;

    return res;

  }

  // vehicle Picks End

  private mobileRenderer = (checkIns: Users.CheckIn[], rowIndex: number) => {
    const { currentUserEmail } = this.props;
    const { coupons, vehiclePickVal } = this.state;
    // const { coupons } = this.state;
    let mobile = this.getCellData(checkIns, rowIndex, "mobile");
    const markForTheft = this.getCellData(checkIns, rowIndex, "markForTheft");
    const markForSellingCar = this.getCellData(checkIns, rowIndex, "markForSellingCar");
    const markUserNotes = this.getCellData(checkIns, rowIndex, "markUserNotes");
    const militaryFirstResopnder = this.getCellData(checkIns, rowIndex, "militaryFirstResopnder");

    const vehiclePickState = {status:false, new:false};

    // vihicle pick code start

    const vehiclePicks = this.getVehiclePics(rowIndex);

      if( checkIns[rowIndex] && mobile && vehiclePickVal[mobile] && vehiclePickVal[mobile].curMobile === checkIns[rowIndex].mobile){


        if(vehiclePickVal[mobile].pickLength === 0){
          vehiclePickState.status = false;
          vehiclePickState.new = false;
        }else{
          if(vehiclePickVal[mobile].newInventory === 1){
            vehiclePickState.status = true;
            vehiclePickState.new = true;
          }else if(vehiclePickVal[mobile].newInventory === 2){
            vehiclePickState.status = true;
            vehiclePickState.new = false;
          }else{
            vehiclePickState.status = false;
            vehiclePickState.new = false;        
          }   
        }


      }else{
        if(vehiclePicks.pickLength === 0){
          vehiclePickState.status = false;
          vehiclePickState.new = false;
        }else{
          if(vehiclePicks.newInventory === 1){
            vehiclePickState.status = true;
            vehiclePickState.new = true;
          }else if(vehiclePicks.newInventory === 2){
            vehiclePickState.status = true;
            vehiclePickState.new = false;
          }else{
            vehiclePickState.status = false;
            vehiclePickState.new = false;        
          }   
        }
  
      }


//    vihicle pick code end


    let couponIconBlock: number = 0;
    if (checkIns[rowIndex]) {
      couponIconBlock = coupons[checkIns[rowIndex].userId];
    }

    if (
      mobile &&
      (currentUserEmail === "cs1@picknpullsa.com" ||
        currentUserEmail === "cs2@picknpullsa.com" ||
        currentUserEmail === "garrett@upullits.com") &&
      mobile !== "6028181729"
    ) {
      // hide the full mobile number.
      mobile = this.obscureMobile(mobile);
    }
    let maskedMobile = "";
    if (mobile) {
      if (mobile !== "6028181729") {
        if (this.props && this.props.currentUser && this.props.currentUser.accountData.permissions.ismask === true) {
          maskedMobile = this.maskNumber(mobile);
        } else {
          maskedMobile = prettyMobile(mobile);
        }
      }
    }

    const membership = this.getCellData(checkIns, rowIndex, "membership");
    const covidquestions = this.getCellData(checkIns, rowIndex, "covidquestions") === "yes" ? true : false;

    let iconMargin = "0px";
    let onlyMiletaryIcon = false;
    // if (mobile && (markUserNotes || markForTheft || markForSellingCar)) {
    if (mobile && (markUserNotes || markForTheft || markForSellingCar || (this.state.vehiclePickBlock && vehiclePickState.status))) {
      iconMargin = "30px";
      onlyMiletaryIcon = false;
    } else if (
      mobile &&
      (militaryFirstResopnder || couponIconBlock) &&
      !(markUserNotes || markForTheft || markForSellingCar)
    ) {
      iconMargin = "26px";
      onlyMiletaryIcon = true;
    }

    return (
      <Cell
        style={{
          ...this.generateCellStyles(membership, covidquestions),
          // Some computers open a dialer when clicking on a mobile number
          background: this.state.tableBackgroundColor,
          border: "0.1px solid " + this.state.tableBorderColor,
          color: this.state.tableFontColor,
          pointerEvents: "none",
        }}
      >
        <div style={{ marginTop: (this.props.checkIns[rowIndex] && this.props.checkIns[rowIndex].userId !== 'opt-out')?iconMargin:'0' }}>
          {mobile
            ? mobile === "6028181729"
              ? "opted-out"
              : maskedMobile
            : // : prettyMobile(mobile)
              undefined}
        </div>
        <div style={{ display:(this.props.checkIns[rowIndex] && this.props.checkIns[rowIndex].userId !== 'opt-out')?'block':'none' }}>
        {/* <div> */}
          {mobile && this.state.vehiclePickBlock? (
              vehiclePickState.status ? (
                <span className="vehicle_picks_icon vehicle_pick_icon_btn">
                  <Button icon="drive-time" className={vehiclePickState.new?'vehicle_icon_green_color':'vehicle_icon_red_color'} />
                  &nbsp;&nbsp;
                </span>
              ) : (
                ""
              )
            ) : (
              ""
          )}

          {mobile ? (
            couponIconBlock ? (
              <span style={{ verticalAlign: onlyMiletaryIcon ? "sub" : "unset" }}>
                <span className="table_coupon_icon">&nbsp;</span>
              </span>
            ) : (
              ""
            )
          ) : (
            ""
          )}
          {mobile ? (
            markUserNotes ? (
              <span className={"table_notes_icon table_asterisk_icon"}>
                <Button icon="asterisk" />
                &nbsp;&nbsp;
              </span>
            ) : (
              ""
            )
          ) : (
            ""
          )}
          {mobile ? (
            markForTheft ? (
              <span className="table_notes_icon">
                <Button icon="warning-sign" />
                &nbsp;&nbsp;
              </span>
            ) : (
              ""
            )
          ) : (
            ""
          )}
          {mobile ? (
            markForSellingCar ? (
              <span className="table_star_icon">
                <Button icon="star" />
                &nbsp;&nbsp;
              </span>
            ) : (
              ""
            )
          ) : (
            ""
          )}
          {mobile ? (
            militaryFirstResopnder ? (
              <span style={{ verticalAlign: onlyMiletaryIcon ? "sub" : "unset" }}>
                <span className="table_american_icon1">&nbsp;</span>
                &nbsp;&nbsp;
              </span>
            ) : (
              ""
            )
          ) : (
            ""
          )}

        </div>
      </Cell>
    );
  };

  private subscribeToCoupons = (checkIns: Users.CheckIn[], rowIndex) => {
    // console.log(rowIndex);
    const { businessId } = this.props;
    if (checkIns.length > 0) {
      checkIns.forEach((ele) => {
        const query = firestore.collection(`users/${ele.userId}/coupons`);

        const couponDta = query.get();
        const coupons: Users.Coupon[] = [];
        let i = 0;

        couponDta.then((dt) => {
          dt.forEach((doc) => {
            const couponId = doc.id;
            const couponData = doc.data() as Users.Coupon;
            if (couponData) {
              const { redemption_flag } = couponData;

              if (redemption_flag === false && businessId === couponData.businessId) {
                coupons.push({ couponId, ...couponData });
                if (couponData.expires_date && couponData.expires_date[`seconds`] > Math.floor(Date.now() / 1000)) {
                  i++;
                }
              }
            }
          });
          this.state.coupons[ele.userId] = i;
        });
      });
    }
  };

  private maskNumber = (num: any) => {
    const x = num.toString().match(/(\d{3})(\d{3})(\d{4})/);
    return "(" + x[1] + ")" + " *** " + x[3];
  };

  private nameRenderer = (checkIns: Users.CheckIn[], rowIndex: number) => {
    const name = this.getCellData(checkIns, rowIndex, "name") as Users.User["name"];
    const membership = this.getCellData(checkIns, rowIndex, "membership");
    const covidquestions = this.getCellData(checkIns, rowIndex, "covidquestions") === "yes" ? true : false;

    if (name) {
      if (name.firstname && name.lastname) {
        let lastName = "";
        if (this.props && this.props.currentUser && this.props.currentUser.accountData.permissions.ismask === true) {
          lastName = "*******";
        } else {
          lastName = name.lastname;
        }
        return (
          <Cell
            style={{
              ...this.generateCellStyles(membership, covidquestions),
              background: this.state.tableBackgroundColor,
              border: "0.1px solid " + this.state.tableBorderColor,
              color: this.state.tableFontColor,
            }}
          >{`${name.firstname} ${lastName}`}</Cell>
        );
      }

      if (name.displayName) {
        return (
          <Cell
            style={{
              ...this.generateCellStyles(membership, covidquestions),
              background: this.state.tableBackgroundColor,
              border: "0.1px solid " + this.state.tableBorderColor,
              color: this.state.tableFontColor,
            }}
          >
            {name.displayName}
          </Cell>
        );
      }
    }

    return (
      <Cell
        style={{
          ...this.generateCellStyles(membership, covidquestions),
          background: this.state.tableBackgroundColor,
          border: "0.1px solid " + this.state.tableBorderColor,
          color: this.state.tableFontColor,
        }}
      />
    );
  };

  private supercardRenderer = (checkIns: Users.CheckIn[], rowIndex: number) => {
    const supercard = this.getCellData(checkIns, rowIndex, "supercard");
    const membership = this.getCellData(checkIns, rowIndex, "membership");
    const covidquestions = this.getCellData(checkIns, rowIndex, "covidquestions") === "yes" ? true : false;

    return (
      <Cell
        style={{
          ...this.generateCellStyles(membership, covidquestions),
          background: this.state.tableBackgroundColor,
          border: "0.1px solid " + this.state.tableBorderColor,
          color: this.state.tableFontColor,
        }}
      >
        {supercard ? supercard.toString() : ""}
      </Cell>
    );
  };

  private covidquestionsRenderer = (checkIns: Users.CheckIn[], rowIndex: number) => {
    const covidquestions = this.getCellData(checkIns, rowIndex, "covidquestions");
    const membership = this.getCellData(checkIns, rowIndex, "membership");
    return (
      <Cell
        style={{
          ...this.generateCellStyles(membership, covidquestions === "yes" ? true : false),
          background: this.state.tableBackgroundColor,
          border: "0.1px solid " + this.state.tableBorderColor,
          color: this.state.tableFontColor,
        }}
      >
        {covidquestions ? covidquestions.toUpperCase() : ""}
      </Cell>
    );
  };

  private formatString = (path)=>{
    const strArr = path.split('-')
    strArr.forEach((ele, index) => {
      strArr[index] = ele.charAt(0).toUpperCase() + ele.slice(1);
    });
    return strArr.join(' ');
  }

  private siteRenderer = (checkIns: Users.CheckIn[], rowIndex: number) => {
    const sitePath = this.getCellData(checkIns, rowIndex, "sitePath");
    const membership = this.getCellData(checkIns, rowIndex, "membership");
    const covidquestions = this.getCellData(checkIns, rowIndex, "covidquestions") === "yes" ? true : false;

    return (
      <Cell
        style={{
          ...this.generateCellStyles(membership, covidquestions),
          background: this.state.tableBackgroundColor,
          border: "0.1px solid " + this.state.tableBorderColor,
          color: this.state.tableFontColor,
        }}
      >
        {/* {sitePath} */}
        {this.formatString(sitePath?sitePath:'')}
      </Cell>
    );
  };

  private timestampRenderer = (checkIns: Users.CheckIn[], rowIndex: number) => {
    const timestamp = this.getCellData(checkIns, rowIndex, "timestamp");
    const membership = this.getCellData(checkIns, rowIndex, "membership");
    const covidquestions = this.getCellData(checkIns, rowIndex, "covidquestions") === "yes" ? true : false;

    const prettyTimestamp = timestamp
      ? format(isTimestamp(timestamp) ? timestamp.toDate() : timestamp, "M/D/YY h:mma")
      : undefined;

    return (
      <Cell
        style={{
          ...this.generateCellStyles(membership, covidquestions),
          background: this.state.tableBackgroundColor,
          border: "0.1px solid " + this.state.tableBorderColor,
          color: this.state.tableFontColor,
        }}
      >
        {prettyTimestamp}
      </Cell>
    );
  };

  private dateRenderer = (checkIns: Users.CheckIn[], rowIndex: number) => {
    const timestamp = this.getCellData(checkIns, rowIndex, "timestamp");
    const membership = this.getCellData(checkIns, rowIndex, "membership");
    const covidquestions = this.getCellData(checkIns, rowIndex, "covidquestions") === "yes" ? true : false;

    const prettyTimestamp = timestamp
      ? format(isTimestamp(timestamp) ? timestamp.toDate() : timestamp, "M/D/YY")
      : undefined;

    return (
      <Cell
        style={{
          ...this.generateCellStyles(membership, covidquestions),
          background: this.state.tableBackgroundColor,
          border: "0.1px solid " + this.state.tableBorderColor,
          color: this.state.tableFontColor,
        }}
      >
        {prettyTimestamp}
      </Cell>
    );
  };

  private timeRenderer = (checkIns: Users.CheckIn[], rowIndex: number) => {
    const timestamp = this.getCellData(checkIns, rowIndex, "timestamp");
    const membership = this.getCellData(checkIns, rowIndex, "membership");
    const covidquestions = this.getCellData(checkIns, rowIndex, "covidquestions") === "yes" ? true : false;

    const prettyTimestamp = timestamp
      ? format(isTimestamp(timestamp) ? timestamp.toDate() : timestamp, "h:mma")
      : undefined;

    return (
      <Cell
        style={{
          ...this.generateCellStyles(membership, covidquestions),
          background: this.state.tableBackgroundColor,
          border: "0.1px solid " + this.state.tableBorderColor,
          color: this.state.tableFontColor,
        }}
      >
        {prettyTimestamp}
      </Cell>
    );
  };

  private mugshotRenderer = (checkIns: Users.CheckIn[], rowIndex: number) => {
    let mugshot = this.getCellData(checkIns, rowIndex, "mugshot");
    if (!mugshot) {
      mugshot = this.getCellData(checkIns, rowIndex, "mugshotUrl");
    }
    const membership = this.getCellData(checkIns, rowIndex, "membership");
    const covidquestions = this.getCellData(checkIns, rowIndex, "covidquestions") === "yes" ? true : false;




    if (mugshot !== null) {
      let mugshotNew = false;

      if(checkIns[rowIndex] && checkIns[rowIndex].businessId === "JlxN1z6LzjJWjXcXlNnG"){
        switch(checkIns[rowIndex].name.firstname){
          case 'Brittany ':
            mugshotNew = true;
            break;
          case 'Michael':
            mugshotNew = true;
            break;
          case 'Rob':
            mugshotNew = true;
            break;
          case 'Shaquille':
            mugshotNew = true;
            break;
          case 'Taylor ':
            mugshotNew = true;
            break;
          case '"The Rock"':
            mugshotNew = true;
            break;
          case 'Tiger':
            mugshotNew = true;
            break;
          case 'Tom':
            mugshotNew = true;
            break;
        }
      }
    
      return (
        <Cell
          style={{
            ...this.generateCellStyles(membership, covidquestions),
            background: this.state.tableBackgroundColor,
            border: "0.1px solid " + this.state.tableBorderColor,
            color: this.state.tableFontColor,
          }}
        >
          {mugshotNew?(
            checkIns[rowIndex].name.firstname === 'Brittany '?
            <img width="100" height="100" src={require("../../images/Brittany_Spears.jpg")} alt="pic" />:''            
          )
          :
          ''}
          {mugshotNew?(
            checkIns[rowIndex].name.firstname === 'Michael'?
            <img width="100" height="100" src={require("../../images/Michael_Jordan.jpg")} alt="pic" />:''            
          )
          :
          ''}
          {mugshotNew?(
            checkIns[rowIndex].name.firstname === 'Rob'?
            <img width="100" height="100" src={require("../../images/Rob_Gronkowski.jpg")} alt="pic" />:''            
          )
          :
          ''}
          {mugshotNew?(
            checkIns[rowIndex].name.firstname === 'Shaquille'?
            <img width="100" height="100" src={require("../../images/Shaq.jpg")} alt="pic" />:''            
          )
          :
          ''}
          {mugshotNew?(
            checkIns[rowIndex].name.firstname === 'Taylor '?
            <img width="100" height="100" src={require("../../images/Taylor_Swift.jpg")} alt="pic" />:''            
          )
          :
          ''}
          {mugshotNew?(
            checkIns[rowIndex].name.firstname === '"The Rock"'?
            <img width="100" height="100" src={require("../../images/The_Rock_Johnson.jpg")} alt="pic" />:''            
          )
          :
          ''}
          {mugshotNew?(
            checkIns[rowIndex].name.firstname === 'Tiger'?
            <img width="100" height="100" src={require("../../images/Tiger_Woods.jpg")} alt="pic" />:''            
          )
          :
          ''}
          {mugshotNew?(
            checkIns[rowIndex].name.firstname === 'Tom'?
            <img width="100" height="100" src={require("../../images/Tom_Brady.jpg")} alt="pic" />:''            
          )
          :
          ''}
          {!mugshotNew?
            <img width="100" height="100" src={mugshot} alt="pic" />            
          :
          ''}
          {/* <img width="100" height="100" src={mugshot} alt="pic" /> */}
        </Cell>
      );
    } else {
      return (
        <Cell
          style={{
            ...this.generateCellStyles(membership, covidquestions),
            background: this.state.tableBackgroundColor,
            border: "0.1px solid " + this.state.tableBorderColor,
            color: this.state.tableFontColor,
          }}
        />
      );
    }
  };

  private assignRenderer = (checkIns: Users.CheckIn[], columnName: Users.ColumnName, rowIndex: number) => {
    switch (columnName) {
      case "dateofbirth":
        return this.dateofbirthRenderer(checkIns, rowIndex);
      case "mobile":
        return this.mobileRenderer(checkIns, rowIndex);
      case "name":
        return this.nameRenderer(checkIns, rowIndex);
      case "site":
        return this.siteRenderer(checkIns, rowIndex);
      case "timestamp":
        return this.timestampRenderer(checkIns, rowIndex);
      case "date":
        return this.dateRenderer(checkIns, rowIndex);
      case "time":
        return this.timeRenderer(checkIns, rowIndex);
      case "mugshot":
        return this.mugshotRenderer(checkIns, rowIndex);
      case "supercard":
        return this.supercardRenderer(checkIns, rowIndex);
      case "covidquestions":
        return this.covidquestionsRenderer(checkIns, rowIndex);
      default:
        return <Cell style={{ ...this.generateCellStyles() }} />;
    }
  };

  private transformSelection = (region: IRegion): IRegion => {
    const rowStart = region.rows && region.rows[0];
    console.log("in func");
    console.log(rowStart);
    if (rowStart || rowStart === 0) {
      return { cols: null, rows: [rowStart, rowStart] };
    } else {
      return region;
    }
  };
  private getLoadingOptions = () => {
    const { loading } = this.props;
    const loadingOptions: TableLoadingOption[] = [];

    if (loading) {
      loadingOptions.push(TableLoadingOption.CELLS);
    }

    return loadingOptions;
  };

  private obscureMobile = (value: string) => {
    const valueArr = value.split("");
    valueArr[4] = "*";
    valueArr[5] = "*";
    valueArr[6] = "*";
    return valueArr.join("");
  };

  private handleColumnsReordered = (oldIndex: number, newIndex: number, length: number) => {
    this.setState({ numColumns: length });
    if (oldIndex === newIndex) {
      return;
    }
    const nextChildren = Utils.reorderArray(this.generateColumns(), oldIndex, newIndex, length);
    this.setState({ columns: nextChildren });
  };
}

export default Table;



// WEBPACK FOOTER //
// ./src/views/CheckIns/Table.tsx